<div style="display: inline-block;">
  <div id="personsSelector">
    <input class="typeahead tt-query {{ (white) ? 'white-field' : ''}}" type="text" placeholder="Type to search named persons" autocomplete="off" spellcheck="false" 
      [(ngModel)]="selectedValue">
  </div>
  <app-loader *ngIf="showLoader"></app-loader>
</div>